<template>
  <div>
    <div>SMS Content</div>
    <div class="text-wrapper">
      <div class="backdrop">
        <div class="highlights">
          <component
            v-for="(message, index) in markDataMessage"
            :is="message.domType"
            :key="index"
            >{{ message.content }}</component
          >
        </div>
      </div>
      <textarea
        class="textArea"
        :rows="5"
        placeholder="Please enter SMS Content"
        v-model="dataMessage"
        resize="none"
        @scroll="linkageScroll"
      >
        <!-- :maxlength="textAreaMax" -->
      </textarea>
    </div>
    <div class="checkmode">
      <label>Check Mode:</label>
      <el-radio-group v-model="checkMode">
        <el-radio :label="1">關閉檢查模式</el-radio>
        <el-radio :label="2">檢查英文短訊</el-radio>
        <!-- <el-radio :label="3">non-big5</el-radio> -->
        <el-radio :label="4">檢查中文短訊</el-radio>
      </el-radio-group>
    </div>
    <div :style="{ position: 'relative', margin: '8px 0' }">
      <div :style="{ position: 'absolute', right: 0 }">
        <label>
          <span
            :style="{ color: previewLength > textAreaMax ? 'red' : 'black' }"
            >{{ previewLength }}</span
          >
          <span>/</span>
          <span>{{ textAreaMax }}</span>
        </label>
      </div>
      <div>Num of messages: {{ splitsNum }}</div>
    </div>
    <div class="step1__checkbox">
      <el-checkbox v-model="otp.flag">Enable OTP Encrytion</el-checkbox>
      <el-checkbox v-model="checked">Enable Shorten URL And Auto UTM</el-checkbox>
    </div>
    <div style="color: #212121">
      USE <span style="color: blue; background-color: yellow">&lt;&lt;PATTERN&gt;&gt;</span> to wrapper the link which should be shorten. e.g. &lt;&lt;https://www.hkbn.net&gt;&gt; or &lt;&lt;[[LINK]]&gt;&gt;
    </div>
    <div v-if="previewLength > textAreaMax" :style="{ color: 'red' }">
      Message too long
    </div>
    <div class="error" v-if="otp.flag && !withOTPLink">
      Please put ##OTP_LINK## in message content when enable OTP link
    </div>
    <div class="otp-input__group" v-show="otp.flag">
      <label>OTP options</label>
      <el-form :model="otp" :rules="rules" ref="form">
        <el-form-item prop="url">
          <el-input placeholder="URL" v-model="otp.url"></el-input>
        </el-form-item>
        <el-form-item prop="pps">
          <el-input placeholder="PPS" v-model="otp.pps"></el-input>
        </el-form-item>
        <el-form-item prop="expiredDate">
          <el-input
            placeholder="Expired date"
            v-model="otp.expiredDate"
          ></el-input>
        </el-form-item>
        <el-form-item prop="qs">
          <el-input placeholder="Query string" v-model="otp.qs"></el-input>
        </el-form-item>
      </el-form>
      <div style="color: #212121">
        ##OTP_LINK## in message content will replace to below link
      </div>
      <div style="color: #333333">[{{ otpLink }}]</div>
    </div>
  </div>
</template>

<script>
import CharCodeUtil from "../utils/CharCodeUtil";
export default {
  data() {
    var validateUrl = (rule, value, callback) => {
      if (/\s/gi.test(value)) {
        callback("Url invalid");
      } else if (!/^http[s]{0,1}:\/\//.test(value)) {
        callback("Please check the url format, e.g. http(s)://");
      } else {
        callback();
      }
    };
    return {
      checkMode: 4,
      dataMessage: "",
      checked: true,
      otp: {
        flag: false,
        url: "",
        pps: "",
        expiredDate: "",
        qs: "",
      },
      rules: {
        url: [{ validator: validateUrl, trigger: "change" }],
        pps: [
          { required: true, message: "Please enter pps", trigger: "change" },
        ],
        expiredDate: [
          {
            required: true,
            message: "Please enter expired date",
            trigger: "change",
          },
        ],
      },
    };
  },
  name: "ContentForm",
  props: ["textAreaMax", "previewLength", "splitsNum", "value"],
  mounted() {
    this.otp.flag &&
      this.$refs["form"].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
  },
  computed: {
    withOTPLink() {
      return /##OTP_LINK##/.test(this.dataMessage);
    },
    otpLink() {
      const { url, pps, expiredDate, qs } = this.otp;
      return `${url}/${pps}/${expiredDate}/##EncrytionKey##${
        qs.length > 0 ? "?" + qs : ""
      }`;
    },
    markDataMessage() {
      if (this.checkMode === 1)
        return [
          {
            component: {
              template: this.dataMessage,
            },
          },
        ];
      const charArr = this.dataMessage.split("");
      const charMap = charArr.map((char) => {
        let marked = false;
        switch (this.checkMode) {
          case 2:
            marked = !CharCodeUtil.isGSMEncode(char);
            break;
          case 3:
            marked = !CharCodeUtil.isBig5(char);
            break;
          case 4:
            marked = !(
              CharCodeUtil.isGSMEncode(char) || CharCodeUtil.isBig5(char)
            );
            break;
          case 1:
          default:
            break;
        }
        return { str: char, marked };
      });

      var arr = [],
        tempStr = "",
        isMarked = charMap[0] ? charMap[0].marked : false,
        i = 0;
      while (i < charMap.length) {
        if (isMarked !== charMap[i].marked) {
          arr.push({
            // name: 'temp-text',
            // component: {
            //   template: isMarked ? `<mark>${tempStr}</mark>` : `<template>${tempStr}</template>`,
            // },
            content: tempStr,
            domType: isMarked ? "mark" : "span",
          });
          tempStr = "";
          isMarked = charMap[i].marked;
        }
        tempStr += charMap[i].str;
        i++;
      }
      arr.push({
        // name: 'temp-text',
        // component: {
        //   template: isMarked ? `<mark>${tempStr}</mark>` : `<template>${tempStr}</template>`,
        // },
        content: tempStr,
        domType: isMarked ? "mark" : "span",
      });
      // eslint-disable-next-line no-console
      console.log(arr);
      return arr;
    },
  },
  watch: {
    value: function (val) {
      const { message, isEnableShorten, otp } = val;
      this.dataMessage = message;
      this.checked = isEnableShorten;
      this.otp = otp;
    },
    dataMessage: function () {
      this.$emit("input", this.getEmitData());
    },
    checked: function () {
      this.$emit("input", this.getEmitData());
    },
    otp: {
      handler() {
        this.$emit("input", this.getEmitData());
      },
      deep: true,
    },
  },
  methods: {
    linkageScroll(e) {
      document.querySelector(".highlights").scrollTo(0, e.target.scrollTop);
    },
    validate() {
      if (this.otp.flag) {
        return new Promise((resolve) => {
          this.$refs["form"].validate((valid) => {
            if (valid) {
              resolve(this.withOTPLink);
            } else {
              resolve(false);
            }
          });
        });
      } else {
        return this.dataMessage.length > 0;
      }
    },
    getEmitData() {
      return {
        message: this.dataMessage,
        isEnableShorten: this.checked,
        otp: this.otp,
        isError: this.isError,
      };
    },
  },
};
</script>

<style lang="css">
.text-wrapper {
  position: relative;
}
.checkmode {
  margin: 8px 0;
}
.step1__checkbox {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0;
}
.error {
  color: red;
}
.otp-input__group .el-row {
  margin: 16px 0;
}
.otp-input__group .el-input {
  width: 400px;
}
.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: bottom;
  z-index: -1;
  font-family: Arial, Helvetica, sans-serif;
  /* overflow: scroll; */
}
.textArea {
  color: #606266;
  background: transparent;
  border: 1px solid #dcdfe6;
}
.textArea:focus {
  border: 1px solid #dcdfe6;
  outline: none !important;
  box-shadow: 0 0 10px #719ece;
}
.textArea,
.highlights {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  /* white-space: pre-wrap; */
  white-space: break-spaces;
  overflow-wrap: break-word;
  resize: none;
  height: 100%;
  letter-spacing: 0px;
}
.highlights {
  overflow: auto;
}
mark {
  border-radius: 3px;
  color: transparent;
  background-color: #b1d5e5;
}
</style>